// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import createTypedReducer, { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

export interface SalesGoalInfoType {
    uri: string;
    annualSalesGoal: number;
    annualSalesGoalDisplay: string;
    yearToDate: number;
    yearToDateDisplay: string;
    properties: any;
}

type SalesGoalState = Readonly<{
    value: SalesGoalInfoType;
}>;

const initialSalesGoalState: SalesGoalState = {
    value: {} as any,
};

const reducer = {
    "xSalesGoal/setValue": (draft: Draft<SalesGoalState>, action: { value: SalesGoalInfoType }) => {
        draft.value = action.value;
    },
};

const xSalesGoal = createTypedReducerWithImmer(initialSalesGoalState, reducer);

(reducers as any).xSalesGoal = xSalesGoal;

export type xSalesGoalState = {
    xSalesGoal: SalesGoalState;
};

type xSalesGoalReducers = {
    value: typeof xSalesGoal;
};

export type xSalesGoalActions = Parameters<xSalesGoalReducers[keyof xSalesGoalReducers]>[1] | AnyAction;
